import router from './router';
import store from './store';

export { router, store };



// WEBPACK FOOTER //
// ./src/app/edit-page/index.js